<template>
  <div
    class="section_background-wrap"
    :style="`height: ${height}; transform: skewY(${skewY}); -webkit-transform: skewY(${skewY}); bottom: ${bottom}`"
  >
    <canvas
      class="gradient-canvas"
      ref="gradientCanvas"
      data-js-darken-top
      data-transition-in
    ></canvas>
  </div>
</template>

<script>
import Gradient from "./gradient";
export default {
  name: "index",
  data() {
    return {
      Gradient
    };
  },
  props: {
    height: {
      default: "110%",
    },
    skewY: {
      default: "5deg",
    },
    bottom: {
      default: "15px",
    },
  },
  methods: {},
  mounted() {
    this.gradient = new Gradient();
    this.gradient.initGradient(this.$refs.gradientCanvas);
  },
  destroyed() {
    this.gradient.pause();
    this.gradient.disconnect();
    this.gradient = null;
  },
};
</script>

<style lang="css" scoped>
.section_background-wrap {
  position: absolute;
  width: 100%;
  /*height:110%;*/
  top: auto;
  /*bottom: 15px;*/
  /*-webkit-transform: skewY(5deg);*/
  /*transform: skewY(5deg);*/
  overflow: hidden;
}
.section_background-wrap:after {
  content: "";
  z-index: -1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  --gradientColorZero: #9200d2;
  --gradientColorOne: #ff0042;
  --gradientColorTwo: #abc9f1;
  --gradientColorThree: #ffcb57;
  --gradientColorZeroTransparent: rgba(146, 0, 210, 0);
  --gradientColorOneTransparent: rgba(255, 0, 66, 0);
  --gradientColorTwoTransparent: rgba(171, 201, 240, 0);
  --gradientColorThreeTransparent: rgba(255, 203, 87, 0);

  background: radial-gradient(
        var(--gradientColorTwo) 30%,
        var(--gradientColorTwoTransparent) 70%
      )
      10px 400px no-repeat,
    radial-gradient(
        var(--gradientColorZero) 10%,
        var(--gradientColorZeroTransparent) 50% 100%
      )
      70px 40px no-repeat,
    radial-gradient(
        var(--gradientColorThree) 30%,
        var(--gradientColorThreeTransparent) 60%
      )
      700px 80px no-repeat,
    radial-gradient(
        var(--gradientColorTwo) 10%,
        var(--gradientColorTwoTransparent) 60% 100%
      ) -200px 80px no-repeat,
    radial-gradient(
        var(--gradientColorOne) 10% 20%,
        var(--gradientColorOneTransparent) 70%
      ) -1000px 600px no-repeat,
    radial-gradient(
        var(--gradientColorZero) 40%,
        var(--gradientColorZeroTransparent) 41% 100%
      ) -600px 180px no-repeat,
    radial-gradient(
        var(--gradientColorThree) 10%,
        var(--gradientColorThreeTransparent) 30%
      )
      100px 50px no-repeat,
    radial-gradient(
        var(--gradientColorOne) 50%,
        var(--gradientColorOneTransparent) 51% 100%
      )
      400px -60px no-repeat,
    radial-gradient(
        var(--gradientColorZero) 0%,
        var(--gradientColorZeroTransparent) 30% 100%
      )
      700px -200px no-repeat,
    radial-gradient(
        var(--gradientColorOne) 40%,
        var(--gradientColorOneTransparent) 70%
      )
      620px -150px no-repeat,
    radial-gradient(
        var(--gradientColorTwo) 20%,
        var(--gradientColorTwoTransparent) 50% 100%
      ) -750px -20px no-repeat var(--gradientColorZero);
}
.gradient-canvas {
  width: 100%;
  height: 100%;
  --gradient-color-1: #8532d3;
  --gradient-color-2: #ff8187;
  --gradient-color-3: #a4cfff;
  --gradient-color-4: #ffbc42;

  opacity: 0;
}
.gradient-canvas.isLoaded{
  opacity: 1;
  transition: opacity 2s ease-in 1s;
}
.section_background-wrap.isLoaded:after{
  transition: transform 1s;
  transform: scaleY(.995);
}
</style>
